<template>
  <div class="main_App">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  name: "App",
  data() {
    return {};
  },
  mounted() {
    let v = this;
  },

  beforeCreate() {},
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("storedata")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("storedata"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("storedata", JSON.stringify(this.$store.state));
    });
    // 兼容iphone手机
    window.addEventListener("pagehide", () => {
      sessionStorage.setItem("storedata", JSON.stringify(this.$store.state));
    });
  },
  beforeDestroy() {
    let v = this;
    Object.assign(v.$data, v.$options.data());
  },

  methods: {},
  computed: {},
};
</script>

<style lang="less" scope>
.main_App {
  height: 100%;
  overflow: hidden;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue